import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from './product';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.baseUrl + 'api/ProductApi')
  }
  Post(product: Product): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/ProductApi/add', product, { headers: header, observe: 'response' })
  }
  Delete(product: Product) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/ProductApi/activeordeactive', product, { headers: header, observe: 'response' })
  }
  Put(product: Product): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/ProductApi/Update', product, { headers: header, observe: 'response' })
  }
  GetActive(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.baseUrl + 'api/ProductApi/GetActive')
  }

}
